import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "success-chapter-view"
};
const _hoisted_2 = {
  class: "success-chapter-title"
};
const _hoisted_3 = {
  class: "success-chapter-preamble"
};
const _hoisted_4 = {
  class: "success-chapter-rate-block"
};
const _hoisted_5 = {
  class: "success-chapter-rate-label"
};
const _hoisted_6 = {
  class: "success-messages-container"
};
const _hoisted_7 = {
  class: "success-messages-container-legend"
};
const _hoisted_8 = {
  class: "success-greater-rate-message-container"
};
const _hoisted_9 = {
  class: "success-lesser-rate-message-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_input = _resolveComponent("w-input");
  const _component_quiz_html_editor = _resolveComponent("quiz-html-editor");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('chapter.successView.title')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('chapter.successView.preamble')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('chapter.successView.rateLabel')), 1), _createVNode(_component_w_input, {
    class: "rate-input",
    value: _ctx.successChapterData?.taux,
    type: "number",
    onChangeInput: _cache[0] || (_cache[0] = $event => _ctx.onRateChange($event))
  }, null, 8, ["value"])]), _createElementVNode("fieldset", _hoisted_6, [_createElementVNode("legend", null, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('chapter.successView.messagesContainer.legend')), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_quiz_html_editor, {
    editorId: _ctx.greaterRateMsgEditorId,
    "custom-editor-config": _ctx.rateMsgEditorConfig,
    "editor-title": _ctx.$t('chapter.successView.greaterRateMsg.title'),
    content: _ctx.realtimeHtmlSuccess,
    onBlur: _ctx.onGreaterRateMsgBlur
  }, null, 8, ["editorId", "custom-editor-config", "editor-title", "content", "onBlur"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_quiz_html_editor, {
    editorId: _ctx.lesserRateMsgEditorId,
    "custom-editor-config": _ctx.rateMsgEditorConfig,
    "editor-title": _ctx.$t('chapter.successView.lesserRateMsg.title'),
    content: _ctx.realtimeHtmlFail,
    onBlur: _ctx.onLesserRateMsgBlur
  }, null, 8, ["editorId", "custom-editor-config", "editor-title", "content", "onBlur"])])])]);
}